module.exports = __webpack_public_path__ + "img/logo-black-premium.c3d4f9b.svg";